import fetchUserService from '../../services/api/user-fetch'
import { useQuery } from 'react-query'
import isAdmin from '../../utilities/is-admin'
import isStudent from '../../utilities/is-student'
import isFacilitator from '../../utilities/is-facilitator'
import useCacheKeys from '../use-cache-keys'
import useApi from '../use-api'

const useUser = ({
    id,
}) => {
    const cacheKeys = useCacheKeys()
    const { api, endpoints, url } = useApi()

    const {
        data: user,
        isLoading: isBusy
    } = useQuery(
        [cacheKeys.USERS, id],
        () => api.get(url(endpoints.user, { userId: id })),
        {
            enabled: id
        }
    )

    return {
        isBusy,
        user,
        isAdmin: isAdmin(user),
        isFacilitator: isFacilitator(user),
        isStudent: isStudent(user),
    }
}

export default useUser